import { LineInterface } from '../../lines/models/line.interface';

export class MmsAssistance {
  step: number;
  phoneNumber: string;
  imeiPhone: number;
  brandPhone: string;
  modelPhone: string;
  system: string;
  activeCellularData: boolean;
  androidVersion?: string;
  otherSystem?: string;
}
